import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataEstas = localStorage.getItem("userDataEstas") ? JSON.parse(base64.decode(localStorage.getItem("userDataEstas"))) : "";
var serviceName = "index";
var urunService = {
    path : "https://www.estasmedikal.com/",
    imageUrlBuyuk: WsProvider.resim + "/" +userDataEstas["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" +userDataEstas["firmaKodu"] + "/kucuk/",
    imageUrlKucuk: WsProvider.resim + "/" +userDataEstas["firmaKodu"] + "/enkucuk/",
    // Kategori
    urunKategoriTanimlama(ustKategori, link, baslik, altBaslik, icerik, resimList, seoBaslik, seoIcerik, icon, durum, dil, opsiyonList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                ustKategori: ustKategori,
                link: link,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                resimList: resimList,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                icon: icon,
                durum: durum,
                dil: dil,
                opsiyonList: opsiyonList,
                serviceName : "urun",
                methodName: "ukategoriTanimlama"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    kategoriList() {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                serviceName : "urun",
                methodName: "ukategoriList"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriDetay(kategoriKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                dil: '',
                serviceName : "urun",
                methodName: "ukategoriDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriGuncelle(kategoriKodu, updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                updateList: updateList,
                serviceName : "urun",
                methodName: "ukategoriGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriKaldir(kategoriKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                serviceName : "urun",
                methodName: "ukategoriKaldir"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriOpsiyonAllList(kategoriKodList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                kategoriKodList: kategoriKodList,
                serviceName : "urun",
                methodName: "ukategoriOpsiyonAllList"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    kategoriOpsiyonAtama(kategoriKodu,opsiyonList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                opsiyonList: opsiyonList,
                serviceName : "urun",
                methodName: "kategoriOpsiyonAtama"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    kategoriOpsiyonList(kategoriKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                serviceName : "urun",
                methodName: "ukategoriOpsiyonList"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },





    // Opsiyon
    urunOpsiyonTanimlama(baslik, yapiskan, konum, durum, dil, kategoriList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                baslik: baslik,
                yapiskan: yapiskan,
                konum: konum,
                durum: durum,
                dil: dil,
                kategoriList: kategoriList,
                serviceName : "urun",
                methodName: "uopsiyonTanimlama"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    opsiyonList() {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                serviceName : "urun",
                methodName: "uopsiyonList"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    opsiyonDetay(opsiyonKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                opsiyonKodu: opsiyonKodu,
                dil: '',
                serviceName : "urun",
                methodName: "uopsiyonDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    opsiyonGuncelle(opsiyonKodu, updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                opsiyonKodu: opsiyonKodu,
                updateList: updateList,
                serviceName : "urun",
                methodName: "uopsiyonGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    opsiyonKaldir(opsiyonKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                opsiyonKodu: opsiyonKodu,
                serviceName : "urun",
                methodName: "uopsiyonKaldir"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },







    // Ürün
    urunCount(durum) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                durum: durum,
                serviceName : "urun",
                methodName: "urunCount"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunTanimla(urunKodu, link, baslik, altBaslik, icerik, resimList, seoBaslik, seoIcerik, durum, dil, kategoriList,opsiyonList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                urunKodu: urunKodu,
                link: link,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                durum: durum,
                resimList: resimList,
                dil: dil,
                kategoriList: kategoriList,
                opsiyonList: opsiyonList,
                serviceName : "urun",
                methodName: "urunTanimlama"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    urunDurumGuncelle(urunKodu, durum) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                urunKodu: urunKodu,
                durum: durum,
                serviceName : "urun",
                methodName: "urunDurumGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunTumListesi(durum, baslangic, limit) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName : "urun",
                methodName: "urunTumListesi"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunDetay(urunKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                urunKodu: urunKodu,
                serviceName : "urun",
                methodName: "urunDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunGuncelle(urunKodu, updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                urunKodu: urunKodu,
                updateList: updateList,
                serviceName : "urun",
                methodName: "urunGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunKategoriGuncelle(urunKodu, updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                urunKodu: urunKodu,
                updateList: updateList,
                serviceName : "urun",
                methodName: "urunKategoriGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOpsiyonGuncelle(urunKodu, updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                urunKodu: urunKodu,
                updateList: updateList,
                serviceName : "urun",
                methodName: "urunOpsiyonGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

};
export default urunService